/* Runtime du clone Lumea SoftGroom — remplace les scripts retirés au build.
   Variant IDs jamais en dur : ils viennent de window.TC_PRODUCT (Liquid). */
(function () {
  "use strict";
  var root = document.querySelector(".tc-clone");
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  // ---------- compte à rebours (les scripts d'origine sont partis) ----------
  function countdown() {
    var digits = $$('[class*="countdown"] [class*="digits"], [class*="countdown__digits"]');
    if (!digits.length) return;
    var end = Number(sessionStorage.getItem("tcClockEnd"));
    if (!end || end < Date.now()) {
      end = Date.now() + 3 * 3600e3 + 12 * 60e3 + 42e3;
      sessionStorage.setItem("tcClockEnd", String(end));
    }
    (function tick() {
      var left = Math.max(0, end - Date.now());
      var h = Math.floor(left / 3600e3),
          m = Math.floor((left % 3600e3) / 60e3),
          s = Math.floor((left % 60e3) / 1000);
      var vals = [h, m, s];
      digits.forEach(function (d, i) {
        var v = vals[i % 3];
        d.textContent = (v < 10 ? "0" : "") + v;
      });
      setTimeout(tick, 1000);
    })();
  }

  // ---------- FAQ : onglets + accordéons ----------
  function faq() {
    $$(".faq-tab[data-target]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var id = tab.getAttribute("data-target");
        $$(".faq-tab").forEach(function (t) { t.classList.toggle("active", t === tab); });
        $$(".faq-section").forEach(function (s) {
          s.classList.toggle("active", s.id === id || s.getAttribute("data-id") === id);
        });
      });
    });
    $$(".faq-question, .faq-item > button, .faq-item__question").forEach(function (q) {
      q.addEventListener("click", function () {
        var item = q.closest(".faq-item") || q.parentElement;
        if (item) item.classList.toggle("open");
      });
    });
    // variante du thème cloné : bouton .faq__summary + panneau .faq__content à hauteur inline
    $$(".faq__summary").forEach(function (q) {
      var item = q.closest(".faq") || q.parentElement;
      var panel = item && item.querySelector(".faq__content");
      if (!panel) return;
      q.addEventListener("click", function () {
        var open = q.getAttribute("aria-expanded") === "true";
        q.setAttribute("aria-expanded", open ? "false" : "true");
        item.classList.toggle("open", !open);
        panel.style.height = open ? "0px" : panel.scrollHeight + "px";
      });
    });
  }

  // ---------- carrousels Splide : piste inerte -> scroll-snap ----------
  function carousels() {
    $$(".splide").forEach(function (sp) {
      $$(".splide__slide--clone", sp).forEach(function (c) { c.remove(); });
      var list = $(".splide__list", sp);
      if (!list) return;
      list.style.transform = "none";
      list.style.display = "flex";
      list.style.gap = "16px";
      list.style.overflowX = "auto";
      list.style.scrollSnapType = "x mandatory";
      list.style.scrollBehavior = "smooth";
      list.style.webkitOverflowScrolling = "touch";
      list.style.scrollbarWidth = "none";
      $$(".splide__slide", list).forEach(function (sl) {
        sl.style.scrollSnapAlign = "center";
        sl.style.flex = "0 0 auto";
        sl.style.position = "static";
        sl.style.opacity = "1";
      });
      var track = $(".splide__track", sp);
      if (track) { track.style.overflow = "visible"; track.style.height = "auto"; }
      sp.style.visibility = "visible";
      var step = function () { return list.clientWidth * 0.85; };
      var prev = $(".splide__arrow--prev", sp), next = $(".splide__arrow--next", sp);
      if (prev) prev.addEventListener("click", function () { list.scrollBy({ left: -step() }); });
      if (next) next.addEventListener("click", function () { list.scrollBy({ left: step() }); });
      $$(".splide__pagination__page", sp).forEach(function (b, i) {
        b.addEventListener("click", function () {
          var sl = $$(".splide__slide", list)[i];
          if (sl) list.scrollTo({ left: sl.offsetLeft - list.offsetLeft });
        });
      });
    });
  }

  // ---------- carrousels Swiper : wrapper inerte -> scroll-snap ----------
  function swipers() {
    $$(".swiper").forEach(function (sw) {
      if (sw.classList.contains("product-thumbs-swiper")) return;
      var wrap = $(".swiper-wrapper", sw);
      if (!wrap) return;
      $$(".swiper-slide-duplicate", wrap).forEach(function (c) { c.remove(); });
      wrap.style.transform = "none";
      wrap.style.display = "flex";
      wrap.style.gap = "26px";
      wrap.style.overflowX = "auto";
      wrap.style.scrollSnapType = "x mandatory";
      wrap.style.scrollBehavior = "smooth";
      wrap.style.scrollbarWidth = "none";
      $$(".swiper-slide", wrap).forEach(function (sl) {
        sl.style.scrollSnapAlign = "start";
        sl.style.flex = "0 0 auto";
        sl.style.marginRight = "0";
        sl.style.position = "static";
        sl.style.height = "auto";
      });
      sw.style.overflow = "hidden";
      $$(".swiper-pagination-bullet", sw).forEach(function (b, i) {
        b.addEventListener("click", function () {
          var sl = $$(".swiper-slide", wrap)[i];
          if (sl) wrap.scrollTo({ left: sl.offsetLeft - wrap.offsetLeft });
        });
      });
    });
  }


  // ---------- galerie produit : miniatures -> visuel principal ----------
  function mediaGallery() {
    var main = $(".product-media-swiper .swiper-wrapper");
    var thumbs = $$(".product-thumbs-swiper .swiper-slide");
    if (!main || !thumbs.length) return;
    var slides = $$(".swiper-slide", main);
    function activate(i) {
      var sl = slides[i];
      if (sl) main.scrollTo({ left: sl.offsetLeft - main.offsetLeft, behavior: "smooth" });
      thumbs.forEach(function (t, j) { t.classList.toggle("is-active", j === i); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { activate(i); }); });
    activate(0);
    var prev = $(".product_main_prev"), next = $(".product_main_next");
    var step = function () { return main.clientWidth; };
    if (prev) { prev.classList.remove("swiper-button-disabled");
                prev.addEventListener("click", function () { main.scrollBy({ left: -step(), behavior: "smooth" }); }); }
    if (next) next.addEventListener("click", function () { main.scrollBy({ left: step(), behavior: "smooth" }); });
  }

  // ---------- galerie produit ----------
  function gallery() {
    var media = $(".product__media-list") || $(".main-gallery");
    $$(".thumbnail-list li, .thumbnail-list button").forEach(function (th, i) {
      th.addEventListener("click", function () {
        if (!media) return;
        var slide = media.children[i];
        if (slide) media.scrollTo({ left: slide.offsetLeft - media.offsetLeft, behavior: "smooth" });
      });
    });
  }

  // ---------- révélation au scroll (le JS du thème a été retiré) ----------
  function reveal() {
    var hidden = $$(".animate--hidden, .animate-item, .animate-section");
    if (!hidden.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.remove("animate--hidden");
        e.target.classList.add("animate--shown");
        io.unobserve(e.target);
      });
    }, { rootMargin: "0px 0px -8% 0px" });
    hidden.forEach(function (el) { io.observe(el); });
  }

  // ---------- panier : variantes de NOTRE produit, jamais celles du concurrent ----------
  function cart() {
    var form = $('form[action*="/cart/add"]');
    var P = window.TC_PRODUCT;
    if (!form || !P) return;

    // purge des champs hérités du concurrent
    $$('input[name="product-id"], input[name="section-id"], input[name^="properties[__kaching"]', form)
      .forEach(function (i) { i.remove(); });

    var idInput = $('input[name="id"]', form);
    if (!idInput) {
      idInput = document.createElement("input");
      idInput.type = "hidden";
      idInput.name = "id";
      form.appendChild(idInput);
    }

    function resolve() {
      var chosen = $$('input[type="radio"]:checked, select', form)
        .map(function (el) { return (el.value || "").trim().toLowerCase(); })
        .filter(Boolean);
      var match = P.variants.filter(function (v) {
        if (!chosen.length) return true;
        var opts = [v.option1, v.option2, v.option3]
          .filter(Boolean).map(function (o) { return String(o).toLowerCase(); });
        return chosen.every(function (c) { return opts.indexOf(c) !== -1; });
      })[0] || P.variants.filter(function (v) { return v.available; })[0] || P.variants[0];
      idInput.value = match.id;
      return match;
    }
    resolve();
    form.addEventListener("change", resolve);

    // offres groupées : le radio choisi pilote la quantité
    var qty = $('input[name="quantity"]', form);
    $$('[data-tc-bundle-qty]').forEach(function (el) {
      el.addEventListener("click", function () {
        if (qty) qty.value = el.getAttribute("data-tc-bundle-qty") || "1";
      });
    });
  }


  // ---------- flèches : le thème cloné n'utilise PAS .swiper-button-next ----------
  // chaque paire est rattachée en remontant jusqu'au premier ancêtre qui contient une piste.
  function arrows() {
    var PAIRS = [
      [".step_btn_prev", ".step_btn_next"],
      [".card_btn_prev", ".card_btn_next"],
      [".tp-button--prev", ".tp-button--next"],
      ['[class*="video-social-btn-prev"]', '[class*="video-social-btn-next"]'],
      [".swiper-button-prev", ".swiper-button-next"]
    ];
    function trackFor(btn) {
      var n = btn;
      for (var i = 0; i < 7 && n; i++) {
        var tracks = n.querySelectorAll ? n.querySelectorAll(".swiper-wrapper") : [];
        for (var j = 0; j < tracks.length; j++) {
          var sw = tracks[j].closest(".swiper");
          if (sw && sw.classList.contains("product-thumbs-swiper")) continue;
          return tracks[j];
        }
        n = n.parentElement;
      }
      return null;
    }
    function bind(btn, dir) {
      if (!btn || btn.dataset.tcBound) return;
      var track = trackFor(btn);
      if (!track) return;
      btn.dataset.tcBound = "1";
      btn.classList.remove("swiper-button-disabled");
      btn.disabled = false;
      btn.addEventListener("click", function () {
        var slide = track.querySelector(".swiper-slide");
        var pas = slide ? slide.getBoundingClientRect().width + 26 : track.clientWidth * 0.9;
        track.scrollBy({ left: dir * pas, behavior: "smooth" });
      });
    }
    PAIRS.forEach(function (p) {
      $$(p[0]).forEach(function (b) { bind(b, -1); });
      $$(p[1]).forEach(function (b) { bind(b, 1); });
    });
  }

  function steps() {
    $$(".nc-dots").forEach(function (dots) {
      var grid = dots.closest(".numbered-content--grid") || document;
      var card = grid.querySelector(".nc-card");
      if (!card) return;
      var img = card.querySelector(".nc-card__thumb");
      var title = card.querySelector(".nc-card__title");
      var desc = card.querySelector(".nc-card__desc");
      var chip = card.querySelector(".nc-chip");
      var btns = [].slice.call(dots.querySelectorAll(".nc-dot"));
      btns.forEach(function (b) {
        b.addEventListener("click", function () {
          btns.forEach(function (o) { o.setAttribute("aria-selected", o === b ? "true" : "false"); });
          if (img && b.dataset.img) { img.removeAttribute("srcset"); img.src = b.dataset.img; }
          if (title && b.dataset.title) title.textContent = b.dataset.title;
          if (desc && b.dataset.desc) desc.textContent = b.dataset.desc;
          if (chip && b.dataset.index) chip.textContent = b.dataset.index;
        });
      });
    });
  }

  function beforeAfter() {
    $$(".before-after-slider-container").forEach(function (box) {
      var before = box.querySelector(".before-image");
      var line = box.querySelector(".slider-line");
      var icon = box.querySelector(".slider-icon");
      var input = box.querySelector("input.slider");
      if (!before || !input) return;
      function apply(v) {
        before.style.width = v + "%";
        if (line) line.style.left = v + "%";
        if (icon) icon.style.left = v + "%";
      }
      input.addEventListener("input", function () { apply(input.value); });
      if (!input.value) input.value = 50;
      apply(input.value);
    });
  }

  function boot() { countdown(); faq(); carousels(); swipers(); mediaGallery(); gallery(); reveal(); cart(); steps(); beforeAfter(); arrows(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
